<!-- Popup thông tin chi tiết CCQ đang giao dịch -->
<div class="modal-contents new-fund">

  <!-- Modal Header -->
  <div class="modal-header">
    <div class="row">
      <div class="col-12 col-sm-8 col-md-8 col-lg-8">
        <label>{{product.name}} ({{product.shortName}})</label>
      </div>
      <button type="button" class="btn close-btn" (click)="dismiss()">
        Đóng
      </button>
    </div>
  </div>

  <!-- Modal body -->
  <div class="modal-body horizon-mobile">
    <div class="row modal-row">
      <div class="col-lg-12 col-sm-12 col-md-12 col-12" *ngIf="product.description">
        <label class="pt-3">{{product.description}}</label>
      </div>
      <div class="col-lg-4 col-sm-12 col-md-12 col-12">
        <div class="card">
          <span>Giá gần nhất</span>
          <div class="group-text">
            <label class="price" for="">{{product.extra?.currentNAV | money}} VND</label>
            <label class="small-des" for="">Cập nhật ngày
              {{product.extra?.lastNAVDate ? (product.extra?.lastNAVDate | date: 'dd/MM/yyyy ') : 'N/A'}}
            </label>
          </div>
          <button class="btn btn--blue btn-onTablet" style="" type="button" (click)="buy()">
            {{'product.buy' | translate}}
          </button>
        </div>

      </div>

      <div class="col-lg-8 col-sm-12 col-md-12 col-12">
        <div class="block block-up">
          <div class="row">
            <div class="col-lg-3 col-sm-3 col-md-3 col-6">
              <div class="block-item">
                <label for="">Tổ chức phát hành</label>
                <span>{{product.owner?.shortName}}</span>
              </div>
            </div>
            <div class="col-lg-5 col-sm-5 col-md-5 col-6">
              <div class="block-item">
                <label for="">{{'product.info_fund.invester_asset' | translate}}</label>
                <span>{{product.productAssetAllocationModel1?.name || '_'}} ,
                  {{product.productAssetAllocationModel2?.name || '_'}}</span>
              </div>
            </div>
            <div class="col-lg-4 col-sm-4 col-md-4 col-6">
              <div class="block-item">
                <label for="">{{'product.transaction_approve_days' | translate}}</label>
                <span>{{product.transactionDate + approveDays || '_'}}</span>
              </div>
            </div>
            <div class="col-lg-3 col-sm-3 col-md-3 col-6">
              <div class="block-item">
                <label for="">{{'product.trading_turn' | translate}}</label>
                <span>{{product.productTradingSession?.tradingTimeString}}</span>
              </div>
            </div>
            <div class="col-lg-5 col-sm-5 col-md-5 col-6">
              <div class="block-item">
                <label for="">Đặt lệnh và chuyển tiền mua</label>
                <span>{{product.productTradingSession?.closedOrderBookString}}</span>
              </div>
            </div>
            <div class="col-lg-4 col-sm-4 col-md-4 col-6">
              <div class="block-item">
                <label for="">{{product.customField}}</label>
                <span>{{product.customValue}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-12 pt-3">
        <div class="fee-list ">
          <div class="row">
            <div class="col-5 md--border__right" *ngIf="product.feeBuys?.length"
              [ngClass]="product.normalTimeHolds?.length ?  'col-5' : 'col-12'">
              <detail-fee [option]="optionBuyFee" [fees]="product.feeBuys"></detail-fee>
            </div>
            <div class="col-5 offset-2"
              *ngIf="product.normalTimeHolds?.length"
              [ngClass]="product.feeBuys?.length ?  'col-5' : 'col-12'">
              <detail-fee [option]="optionSellFee" [fees]="product.normalTimeHolds"></detail-fee>
            </div>
          </div>
        </div>
        <div class="col-lg-12 p-0 pt-3 pb-3">
          <button class="btn btn--blue btn-desk" style="width: 100%" type="button" (click)="buy()">
            {{'product.buy' | translate}}
          </button>
        </div>
      </div>



    </div>
  </div>
  <div class="modal-footer">
    <div class="row w-100 m-0">
      <div class="col-6">
        <button class="btn close-btn w-100" type="button" (click)="dismiss()">Đóng</button>
      </div>
      <div class="col-6">
      </div>
    </div>

  </div>
</div>